define('app/sdc/input/sdc-input',[],function () {
	"use strict";
	undefined;
	return {
		model: {
			"ngModel": "=?",
			"type": "@?",
			"_labelClass": "@?labelClass",
			"name": "@?"
		},
		controller: {
			properties: {
				labelClass: function () { return (this._labelClass === undefined || this._labelClass === null) ? "sr-only" : this._labelClass; },
				inputClass: function () { return (this._inputClass === undefined || this._inputClass === null) ? "form-control" : this._inputClass; },
			}
		}
	};
});
